<!--
 * @Descripttion: 个人中心
 * @Author: chenjinsheng
 * @Date: 2021-09-22 09:31:54
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-18 17:57:04
-->
<template>
    <div class="box">
        <div
            :class="[
                'user-center-box',
                { 'user-guide-step4': steps.step4 || steps.step5 || steps.step7 },
                { 'user-guide-step6': steps.step6 },
            ]"
        >
            <div class="user-center-box-first">
                <div :class="['user-center-box-first-right', { 'user-guide-person-info': steps.step2 }]">
                    <!-- 头像 -->
                    <user-center-info></user-center-info>
                </div>
                <div class="user-center-box-first-left">
                    <!-- 图片  -->
                    <div class="user-center-box-first-left-top">
                        <el-carousel>
                            <el-carousel-item v-for="(item, index) in records" :key="index">
                                <div
                                    class="img-wrap"
                                    :style="{ 'background-image': 'url(' + item.image + ')' }"
                                    :class="{
                                        'link-show':
                                            !['', undefined, NaN, null].includes(item.url) || item.advertType === 2,
                                    }"
                                    @click="openWin(item)"
                                ></div>
                                <span v-show="item.showTitle" class="ad-title"> {{ item.title }}</span>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <!-- 自助查 -->
                    <div class="user-center-box-first-left-bottom">
                        <user-center-lpservices></user-center-lpservices>
                    </div>
                </div>
            </div>
            <div class="user-center-box-second">
                <div class="user-center-box-second-right">
                    <!-- 我的绩效 -->
                    <user-center-Performance></user-center-Performance>
                </div>
                <div class="user-center-box-second-left">
                    <!-- 办事大厅  -->
                    <user-center-offer></user-center-offer>
                </div>
            </div>
            <div class="user-center-box-third">
                <div class="user-center-box-third-right">
                    <!-- 我的学习 -->
                    <user-center-study></user-center-study>
                </div>
                <div class="user-center-box-third-left">
                    <!-- 员工福利 -->
                    <user-center-weal></user-center-weal>
                </div>
            </div>
            <div class="user-center-box-fourth">
                <!-- 文化活动 -->
                <user-center-culture></user-center-culture>
            </div>
            <div></div>
        </div>
    </div>
</template>

<script>
import UserCenterInfo from "./components/user-center-info.vue";
import UserCenterLpservices from "./components/user-center-lpservices.vue";
import UserCenterOffer from "./components/user-center-offer.vue";
import UserCenterStudy from "./components/user-center-study.vue";
import UserCenterWeal from "./components/user-center-weal.vue";
import UserCenterCulture from "./components/user-center-culture.vue";
import UserCenterPerformance from "./components/user-center-performance.vue";
import { mapState } from "vuex";
import { advList } from "@/api";
export default {
    name: "UserCenter",
    components: {
        UserCenterInfo,
        UserCenterLpservices,
        UserCenterOffer,
        UserCenterStudy,
        UserCenterWeal,
        UserCenterCulture,
        UserCenterPerformance,
    },

    data() {
        return {
            defaultImg:
                "http://nhfcloms-admin-dev.oss-cn-beijing.aliyuncs.com/dwwb/portal/project/1637229323857/%E4%BD%8D%E5%9B%BE%E5%A4%87%E4%BB%BD%202%402x.png",
            params: {
                current: 1,
                size: 20,
                isLate: 0,
                adPositionId: 2,
            },
            records: [],
        };
    },
    computed: {
        ...mapState({
            steps: (state) => state.guide.userSteps,
        }),
    },
    mounted() {
        this.getBannerList();
    },
    methods: {
        async getBannerList() {
            try {
                const { body, code, message } = await advList({
                    ...this.params,
                });
                if (code === "0000") {
                    const bannerList = body ? body.records.slice(0, 5) : [];
                    if (bannerList.length === 0) {
                        bannerList.push({
                            image: this.defaultImg,
                        });
                    }
                    this.records = bannerList;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
        },
        openWin(item) {
            if (item.advertType === 2) {
                this.$router.push(`/work-portal/adv-details?id=${item.id}`);
            } else {
                if (item.url) {
                    window.open(item.url);
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.box {
    width: 100%;
    padding-top: 20px;
    font-size: 14px;
    .user-center-box {
        width: calc(100%-14%);
        margin-left: 7%;
        margin-right: 7%;
        &.user-guide-step4 {
            margin-top: -535px;
        }
        &.user-guide-step6 {
            margin-top: -680px;
        }
        .user-center-box-first {
            height: 508px;
            margin-bottom: 20px;
            display: flex;
            .user-center-box-first-right {
                flex: 1;
                background: #ffffff;
                margin-right: 20px;
                height: 508px;
                &.user-guide-person-info {
                    position: relative;
                    z-index: 999;
                    background-color: #fff;
                    border-radius: 8px;
                    border: 2px solid #3a9d80;
                    pointer-events: none;
                }
            }
            .user-center-box-first-left {
                display: flex;
                flex-wrap: wrap;
                .user-center-box-first-left-top {
                    width: 100%;
                    height: 180px;
                    background: #ffffff;
                    border-radius: 8px;
                    margin-bottom: 20px;

                    /deep/ .el-carousel__container {
                        width: 100%;
                        height: 100px;
                        background: linear-gradient(270deg, #002306 0%, #0a2d10 58%, #002306 100%);
                    }
                    /deep/ .el-carousel {
                        position: relative;
                    }
                    /deep/ ul.el-carousel__indicators--horizontal {
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        position: absolute !important;
                        bottom: 0 !important;
                        right: 0 !important;
                        transform: none !important;
                        padding-right: 5%;
                    }
                    // 未选中状态
                    /deep/ .el-carousel__indicator .el-carousel__button {
                        background: #959595;
                        border-radius: 50%;
                        height: 12px;
                        width: 12px;
                    }
                    // 选中状态
                    /deep/ .el-carousel__indicator.is-active .el-carousel__button {
                        background: #fff;
                    }
                    /deep/ .el-carousel__container {
                        height: 180px;
                        border-radius: 8px;
                        .el-carousel__item {
                            border-radius: 8px;
                            .img-wrap {
                                width: 100%;
                                height: 100%;
                                background-position: center center;
                                background-attachment: scroll;
                                background-size: cover;
                                -webkit-background-size: cover;
                                background-repeat: no-repeat;
                            }
                            .link-show {
                                cursor: pointer;
                            }
                            .ad-title {
                                display: inline-block;
                                height: 38px;
                                line-height: 38px;
                                position: absolute;
                                bottom: 0px;
                                right: 20%;
                                font-size: 18px;
                                color: #fff;
                                font-weight: bold;
                                font-family: "黑体";
                            }
                        }
                    }
                    img {
                        height: 100%;
                        width: 100%;
                        border-radius: 8px;
                        object-fit: contain;
                    }
                }
                .user-center-box-first-left-bottom {
                    width: 100%;
                    height: 308px;
                    background: #ffffff;
                    border-radius: 8px;
                }
            }
        }
        .user-center-box-second {
            width: 100%;
            height: 280px;
            margin-bottom: 20px;
            display: flex;
            .user-center-box-second-right {
                width: 408px;
                background: #ffffff;
                border-radius: 8px;
                margin-right: 20px;
            }
            .user-center-box-second-left {
                width: 100%;
                border-radius: 8px;
                background: white;
            }
        }
        .user-center-box-third {
            width: 100%;
            height: 236px;
            display: flex;
            margin-bottom: 20px;
            .user-center-box-third-right {
                width: 408px;
                height: 236px;
                background: #ffffff;
                border-radius: 8px;
                margin-right: 20px;
            }
            .user-center-box-third-left {
                width: 100%;
                height: 236px;
                border-radius: 8px;
                background: white;
            }
        }
        .user-center-box-fourth {
            width: 100%;
            height: 236px;
            background: #ffffff;
            border-radius: 8px;
            margin-bottom: 20px;
        }
    }
}
</style>
